// extracted by mini-css-extract-plugin
export default {"container":"VW-z","title":"WW-z","link":"XW-z"};